import nper from '../../../utils/nperFunction';
import { getComparisonRate } from '../api';

async function keyFactsCalculations(inputs, { settlementFee, onGoingFeePerYear, dischargeFee }) {
  const assumptions = {
    settlementFee,
    onGoingFeePerYear,
    dischargeFee,
  }
  const data = await getComparisonRate(inputs.loanAmount, settlementFee, onGoingFeePerYear, dischargeFee, inputs.matchingLoans, inputs.termOfLoan)

  async function calculatePersonalisedComparisonRate() {
    let rate = data.Rate.split('%')[0]
    return Number(rate).toFixed(2);
  }

  function calculateThisMeansYouWillPayBack(totalAmountToBePaidBack, loanAmount) {
    return totalAmountToBePaidBack / loanAmount
  }

  // vr = variable rate calculations ------------------------------
  function vrCalculateTotalAmountToBePaidBack() {
    const total = parseInt(data.TP.replace(/[$,]/g, ''), 10);
    return total
  }

  function vrCalculateRepaymentPerMonth() {
    const repaymentPerMonth = parseFloat(data.IRe.replace(/[$,]/g, ''))
    return repaymentPerMonth + (assumptions.onGoingFeePerYear / 12);
  }

  function vrCalculateRepaymentPerYear(repaymentPerMonth) {
    return repaymentPerMonth * 12
  }

  function vrCalculateWhatHappensIf(loanAmount, matchingLoans, termOfLoan, ongoingFees, repaymentPerMonth) {
    return (loanAmount * ((matchingLoans + 0.01 )/ 12)) / (1 - ((1 + ((matchingLoans + 0.01) / 12)) ** (- 12 * termOfLoan))) - repaymentPerMonth
  }

  function vrCalculateIncreasedRepaymentBy(repaymentPerMonth) {
    return repaymentPerMonth + 200
  }

  function vrCalculateHowCanIRepayMyLoanFaster(matchingLoans, increasedRepaymentBy, ongoingFees, loanAmount) {
    const rate = matchingLoans / 12
    const paymentAmount = increasedRepaymentBy - (ongoingFees / 12)
    const present = - loanAmount
    return nper(rate, paymentAmount, present)
  }

  let outputs;

  const repaymentPerMonth = vrCalculateRepaymentPerMonth()
  const totalAmountToBePaidBack = vrCalculateTotalAmountToBePaidBack()
  const personalisedComparisonRate = await calculatePersonalisedComparisonRate(inputs.termOfLoan, totalAmountToBePaidBack, inputs.loanAmount);
  const thisMeansYouWillPayBack = calculateThisMeansYouWillPayBack(totalAmountToBePaidBack, inputs.loanAmount)
  const repaymentPerYear = vrCalculateRepaymentPerYear(repaymentPerMonth)
  const whatHappensIf = vrCalculateWhatHappensIf(inputs.loanAmount, inputs.matchingLoans, inputs.termOfLoan, assumptions.onGoingFeePerYear, repaymentPerMonth)
  const increasedRepaymentBy = vrCalculateIncreasedRepaymentBy(repaymentPerMonth)
  const howCanIRepayMyLoanFaster = vrCalculateHowCanIRepayMyLoanFaster(inputs.matchingLoans, increasedRepaymentBy, assumptions.onGoingFeePerYear, inputs.loanAmount)
  const ongoingFeesPerYear = assumptions.onGoingFeePerYear * 12
  outputs = {
    interestRate: inputs.matchingLoans,
    personalisedComparisonRate,
    totalAmountToBePaidBack,
    thisMeansYouWillPayBack,
    establishmentFees: assumptions.settlementFee,
    ongoingFeesPerMonth: assumptions.onGoingFeePerYear > 0 ? assumptions.onGoingFeePerYear / 12 : 0,
    ongoingFees: assumptions.onGoingFeePerYear,
    ongoingFeesPerYear,
    repaymentPerMonth,
    repaymentPerYear,
    whatHappensIf,
    increasedRepaymentBy,
    howCanIRepayMyLoanFaster
  }

  return outputs
}


export default keyFactsCalculations
